import { render, staticRenderFns } from "./PopupAddProjectMember.vue?vue&type=template&id=5446a24a"
import script from "./PopupAddProjectMember.vue?vue&type=script&lang=ts"
export * from "./PopupAddProjectMember.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports